<template>
  <div class="modal-detailpo">
    <Email v-if="$store.state.modalStore.showModalEmail" />
    <EmailPreview v-if="$store.state.modalStore.showSpmEmailPreview" />
    <div class="mdp-wrapper">
      <div class="mdp-event-title">PERIODE EVALUASI KONTRAK</div>
      <div class="mdp-radio" v-for="(item, index) in filters" :key="index">
        <label class="mr20" :for="item.value">
          <input class="mr5" type="radio" :value="item.value" name="PERIODE PO" v-model="choosePeriodeKontrak" />
          {{ item.name }}
        </label>
      </div>
    </div>
    <div class="custom-po">
      <div class="text-danger text-bold">Kostum</div>
      <div class="input-wrap">
        <input type="date" v-model="spmStartDate" />
      </div>
      <div>s/d</div>
      <div class="input-wrap">
        <input type="date" v-model="spmEndDate" />
      </div>
      <div @click="runCustomDate()">
        <strong class="search-icons"><i class="fas fa-search"></i></strong>
      </div>
    </div>
    <div v-show="spmChart">
      <ChartKinerjaKontrak :chartData="chartData" :options="options" :height="275" />
      <div class="w-100 d-flex flex-wrap justify-content-center align-items-center spm-legend">
        <span class="mr-1 ml-1 legend-desc d-flex flex-wrap justify-content-center align-items-center"><i
            class="material-icons legend-bad">fiber_manual_record</i> Sangat
          Buruk</span>
        <span class="mr-1 ml-1 legend-desc d-flex flex-wrap justify-content-center align-items-center">
          <i class="material-icons legend-not-bad">fiber_manual_record</i> Tidak
          Memuaskan</span>
        <span class="mr-1 ml-1 legend-desc d-flex flex-wrap justify-content-center align-items-center"><i
            class="material-icons legend-good-enough">fiber_manual_record</i>
          Cukup Memuaskan</span>
        <span class="mr-1 ml-1 legend-desc d-flex flex-wrap justify-content-center align-items-center"><i
            class="material-icons  legend-enough">fiber_manual_record</i>
          Memuaskan</span>
        <span class="mr-1 ml-1 legend-desc d-flex flex-wrap justify-content-center align-items-center"><i
            class="material-icons  legend-satisfy">fiber_manual_record</i>
          Sangat Memuaskan</span>
      </div>
    </div>
    <div class="kinerja-list-container" v-if="spmDetail">
      <div class="kinerja-list-wrapper">
        <div class="kinerja-list klc-title">
          <div class="kinerja-list__project-name">Nama Projek</div>
          <div class="kinerja-list__efective-date" @click="orderByDate()" style="cursor:pointer">
            Tgl Efektif
            <i class="fas fa-sort-numeric-down-alt" v-show="$store.state.level1.kinerjaKontrakOrder == 'desc'"></i><i
              class="fas fa-sort-numeric-up" v-show="$store.state.level1.kinerjaKontrakOrder == 'asc'"></i>
          </div>
          <div class="kinerja-list__average-value">Nilai Akumulatif</div>
          <div class="kinerja-list__desc">Keterangan</div>
          <div class="kinerja-list__view"></div>
          <div class="kinerja-list__send-mail"></div>
        </div>
      </div>
      <div class="kinerja-list-wrapper" v-for="(list, index) in spmDetail" :key="index">
        <div class="kinerja-list">
          <div class="kinerja-list__project-name">{{ list.project_name }}</div>
          <div class="kinerja-list__efective-date">
            {{ formatDate(list.period_from) }}
          </div>
          <div class="kinerja-list__average-value ">
            {{ parseFloat(list.total_avg).toFixed(0) }}
          </div>
          <div class="kinerja-list__desc">
            {{ vendorCategory(list.total_avg) }}
          </div>
          <div class="kinerja-list__view text-center" @click="setShowDetail(index)">
            <i class="fas fa-bars"></i>
          </div>
          <div class="kinerja-list__send-mail text-center" @click="openModal(list)">
            <i class="far fa-envelope"></i>
          </div>
        </div>
        <div class="kinerja-detail-container" v-if="isShowDetail == index">
          <div class="kinerja-detail-wrapper kdc-title">
            <div class="kdw-penilaian">Kriteria Penilaian</div>
            <div class="kdw-efective-date">Tgl Efektif Evaluasi</div>
            <div class="kdw-end-date">Tgl Berakhir Evaluasi</div>
            <div class="kdw-average-score">Nilai</div>
          </div>
          <div class="kinerja-detail-wrapper" v-for="(item, i) in list.spm_detail" :key="i">
            <div class="kdw-penilaian">{{ item.kriteria_penilaian }}</div>
            <div class="kdw-efective-date">
              {{ formatDate(item.spm_performance_period_from) }}
            </div>
            <div class="kdw-end-date">
              {{ formatDate(item.spm_performance_period_to) }}
            </div>
            <div class="kdw-average-score">{{ item.average_grade }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import numeral from 'numeral'
export default {
  components: {
    Email: () => import('@/components/spmscoringEmail'),
    EmailPreview: () => import('@/components/modal/emailPreview'),
    ChartKinerjaKontrak: () =>
      import('@/components/chart/ChartKinerjaKontrak.vue'),
  },
  data() {
    return {
      isShowDetail: null,
      emailModalShow: false,
      filters: [
        {
          name: '6 Bulan',
          value: '6',
        },
        {
          name: '12 Bulan',
          value: '12',
        },
        {
          name: '24 Bulan',
          value: '24',
        },
      ],
      chartData: null,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
          datalabels: {
            color: '#000000',
            formatter: function (value, context) {
              let idr = numeral(value).format('0,0.00')
              let newIdr = ''
              idr.split('').map(list => {
                if (list == ',') {
                  newIdr += '.'
                } else if (list == '.') {
                  newIdr += ','
                } else {
                  newIdr += list
                }
              })
              return newIdr
            },
          },
        },
        title: {
          display: true,
          text: 'Kinerja Kontrak',
        },
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              let idr = numeral(tooltipItem.yLabel).format('0,0.00')
              let newIdr = ''
              idr.split('').map(list => {
                if (list == ',') {
                  newIdr += '.'
                } else if (list == '.') {
                  newIdr += ','
                } else {
                  newIdr += list
                }
              })

              label += newIdr
              return label
            },
          },
        },
        scales: {
          xAxes: [],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Nilai Rata-rata',
              },
              ticks: {
                max: 100,
                stepSize: 10,
                beginAtZero: true,
              },
            },
          ],
        },
      },
    }
  },
  computed: {
    spmChart() {
      this.seriesData()
      return this.$store.state.level1.spmChart
    },
    spmDetail() {
      const detail = this.spmClassification(this.$store.state.level1.spmDetail)
      return detail
    },
    choosePeriodeKontrak: {
      get: function () {
        return this.$store.state.searchStore.choosePeriodeKontrak
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'spmStartDate',
          value: this.monthFromNow(newValue),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'spmEndDate',
          value: this.$now(),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePeriodeKontrak',
          value: newValue,
        })

        let query = {
          startDate: `${this.monthFromNow(newValue)}`,
          endDate: `${this.$now()}`,
        }

        await this.$store.commit('level1/CUSTOM_KINERJA_KONTRAK', query)
      },
    },
    spmStartDate: {
      get: function () {
        return this.$store.state.searchStore.spmStartDate
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'spmStartDate',
          value: newValue,
        })
      },
    },
    spmEndDate: {
      get: function () {
        return this.$store.state.searchStore.spmEndDate
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'spmEndDate',
          value: newValue,
        })
      },
    },
  },
  methods: {
    async seriesData() {
      const self = this
      const items = self.$store.state.level1.spmChart

      let newCategories = []
      let eCount = []
      let colors = []

      items &&
        items.forEach(list => {
          newCategories.push(this.formatDate(list.SPM_PERFORMANCE_PERIOD_TO))
          eCount.push(list.grade)
          colors.push(this.labelColors(list.grade))
        })

      this.chartData = {
        labels: newCategories,
        datasets: [
          {
            label: 'Nilai Rata-Rata',
            backgroundColor: colors,
            data: eCount,
          },
        ],
      }
    },
    labelColors(value) {
      if (value >= 95) {
        return '#ff9966'
      } else if (value >= 80 && value < 95) {
        return '#ff9900'
      } else if (value >= 70 && value < 80) {
        return '#ff6600'
      } else if (value > 50 && value <= 69) {
        return '#ff3333'
      } else if (value >= 0 && value <= 50) {
        return '#990000'
      }
    },
    async runCustomDate() {
      const query = {
        startDate: `${this.spmStartDate}`,
        endDate: `${this.spmEndDate}`,
      }

      await this.$store.commit('level1/CUSTOM_KINERJA_KONTRAK', query)
    },
    orderByDate() {
      this.$store.commit('level1/ORDER_KINERJA_KONTRAK')
    },
    setShowDetail(value) {
      if (this.isShowDetail == null || this.isShowDetail != value) {
        this.isShowDetail = value
      } else {
        this.isShowDetail = null
      }
    },
    getSemester(value) {
      if (new Date(value).getMonth() + 1 > 6) {
        return 2
      }
      return 1
    },
    async openModal(value) {
      const self = this
      this.$store.commit('modalStore/SET_MODAL_DATA', {
        value: true,
        name: 'showModalEmail'
      })
      this.$store.commit('modalStore/SET_MODAL_DATA', {
        value: {
          supplier_name: await value.supplier,
          project_name: await value.project_name,
          score: await self.avgCalculation(value.spm_detail),
          category: await self.vendorCategory(
            self.avgCalculation(value.spm_detail)
          ),
          semester: await self.getSemester(value.period_to),
          tahun: await new Date(value.period_to).getFullYear(),
          detail: await value.spm_detail,
        },
        name: 'spmEmail'
      })
    },
    async sendMail(value) {
      const self = this
      try {
        if (self.$get(self.$store, 'state.permissions.53.allow')) {
          let spmScore = {
            supplier_name: await value.supplier,
            project_name: await value.project_name,
            score: await self.avgCalculation(value.spm_detail),
            category: await self.vendorCategory(
              self.avgCalculation(value.spm_detail)
            ),
            semester: await self.getSemester(value.period_to),
            tahun: await new Date(value.period_to).getFullYear(),
            detail: await value.spm_detail,
          }

          await self.$store.dispatch('modalStore/setDataEmail', spmScore)
        } else {
          self.$store.commit(
            'DONT_HAVE_PERMISSIONS',
            `${self.$get(
              self.$store,
              'state.permissions.53.modul'
            )}, ${self.$get(self.$store, 'state.permissions.53.function')}`
          )
        }
      } catch (error) { }
    },
    avgCalculation(items) {
      let chartData = this.$store.state.level1.spmChart
      let count = 0
      let cal = 0
      items &&
        items.forEach(value => {
          if (value.average_grade > 0) {
            cal += parseFloat(value.average_grade)
            count += 1
          }
        })
      if (count > 0) {
        return parseFloat(cal / count).toFixed(0)
      }
      return 0
    },
    sumAvgCalculation(project_name, period_to) {
      let chartData = this.$store.state.level1.spmChart

      let getSum = chartData.filter(i => i.PROJECT_NAME == project_name)

      if (getSum.length > 0) {
        return getSum[0].grade
      }
      return 0
    },
    spmClassification(items) {
      const self = this
      if (items) {
        const spmData = items
        let spmObj = {}

        for (let i in spmData) {
          let spm = spmData[i]

          if (spmObj[`${spm['PROJECT_NAME']}`] == undefined) {
            spmObj[`${spm['PROJECT_NAME']}`] = {
              commodity: spm['COMMODITY'],
              supplier: spm['VENDOR_NAME'],
              project_name: spm['PROJECT_NAME'],
              period_from: spm['SPM_PERFORMANCE_PERIOD_FROM'],
              period_to: spm['SPM_PERFORMANCE_PERIOD_TO'],
              total_average_score: 70,
              vendor_category: 'Memuaskan',
              spm_detail: [
                {
                  kriteria_penilaian: spm['KRITERIA_PENILAIAN'],
                  spm_performance_period_from:
                    spm['SPM_PERFORMANCE_PERIOD_FROM'],
                  spm_performance_period_to: spm['SPM_PERFORMANCE_PERIOD_TO'],
                  average_grade:
                    spm['AVG_GRADE'] && Number(spm['AVG_GRADE']).toFixed(0),
                },
              ],
            }
          } else {
            spmObj[`${spm['PROJECT_NAME']}`]['period_from'] =
              spm['SPM_PERFORMANCE_PERIOD_FROM']
            spmObj[`${spm['PROJECT_NAME']}`]['period_to'] =
              spm['SPM_PERFORMANCE_PERIOD_TO']
            spmObj[`${spm['PROJECT_NAME']}`]['spm_detail'].push({
              kriteria_penilaian: spm['KRITERIA_PENILAIAN'],
              spm_performance_period_from: spm['SPM_PERFORMANCE_PERIOD_FROM'],
              spm_performance_period_to: spm['SPM_PERFORMANCE_PERIOD_TO'],
              average_grade:
                spm['AVG_GRADE'] && Number(spm['AVG_GRADE']).toFixed(0),
            })
            spmObj[`${spm['PROJECT_NAME']}`]['total_avg'] = this.sumAvgCalculation(spm['PROJECT_NAME'], spm['SPM_PERFORMANCE_PERIOD_TO'])
          }
        }

        let newSPM = []
        let obj = Object.entries(spmObj)

        for (let i in obj) {
          newSPM.push(obj[i][1])
        }
        return newSPM
      }
    },
    vendorCategory(score) {
      if (score >= 95) {
        return 'Sangat Memuaskan'
      } else if (score >= 80 && score < 95) {
        return 'Memuaskan'
      } else if (score >= 70 && score < 80) {
        return 'Cukup Memuaskan'
      } else if (score > 50 && score <= 69) {
        return 'Tidak Memuaskan'
      } else if (score >= 0 && score <= 50) {
        return 'Sangat Buruk'
      }
    },
  },
}
</script>
<style lang="scss"></style>
